// JRS
export const JRS_CONSTANTS = {
  TEMP_ID_PREFIX: 'temp_',
}

// User Store
export const USER_STORE_CONSTANTS = {
  TIMESTAMP_MINIMUM_NUMBER: 10000000000,
}
